class Type {
	public static HORIZONTAL = new Type("layout1", "Horizontal");
	public static VERTICAL = new Type("layout2", "Vertical");

	private constructor(
		public readonly id: string,
		public readonly label: string,
	) {
	}

	public get horizontal() {
		return this === Type.HORIZONTAL;
	}

	public get vertical() {
		return this === Type.VERTICAL;
	}

	public static get default(): Type {
		return this.HORIZONTAL;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id?: string) {
		return this.values().find((value) => value.id === id);
	}

	public static getByIdOrDefault(id?: string): Type {
		return this.getById(id) || this.default;
	}

}

export { Type as BioPageLayoutType };
